export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_lemon.1ad61c81.jpg";